function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["activatePanelOnPrevNext", "caption", "changeToIndex", "className", "id", "initialActiveIndex", "loaderLabel", "loading", "onChange", "showSlider", "showUnderline", "tabButtonProps", "tabListProps", "tabPanelProps", "tabSliderProps", "tabUnderlineProps", "tabs"];
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import classnames from 'classnames';
import React, { useState, useEffect } from 'react';
import "../../../../enums/accordion.js";
import "../../../../enums/alert.js";
import "../../../../enums/avatar.js";
import "../../../../enums/breakpoints.js";
import "../../../../enums/button.js";
import "../../../../enums/code-editor.js";
import "../../../../enums/colors.js";
import "../../../../enums/combobox.js";
import "../../../../enums/date.js";
import "../../../../enums/drag-and-drop.js";
import "../../../../enums/dialog.js";
import "../../../../enums/divider.js";
import "../../../../enums/dropdown.js";
import "../../../../enums/fieldset.js";
import "../../../../enums/font-icon.js";
import "../../../../enums/fonts.js";
import "../../../../enums/headings.js";
import "../../../../enums/input.js";
import "../../../../enums/keys.js";
import "../../../../enums/list.js";
import "../../../../enums/listbox.js";
import "../../../../enums/loader.js";
import "../../../../enums/margin.js";
import "../../../../enums/option.js";
import "../../../../enums/pill.js";
import "../../../../enums/placements.js";
import "../../../../enums/popout.js";
import "../../../../enums/privacy.js";
import "../../../../enums/radio-group.js";
import "../../../../enums/status.js";
import "../../../../enums/switch.js";
import "../../../../enums/table.js";
import "../../../../enums/tooltip.js";
import "../../../../enums/transitions.js";
import "../../../../enums/widths.js";
import "../../../atoms/icon/font-icon/font-icon.js";
import 'react-transition-group';
import "../../../atoms/alert/inline-alert/inline-alert.js";
import "../../../atoms/alert/standard-alert/standard-alert.js";
import 'boring-avatars';
import "../../../atoms/tooltip/hover-tooltip/hover-tooltip.js";
import 'react-laag';
import "../../../../styles/styled-components/alert.js";
import "../../../../styles/styled-components/animations.js";
import "../../../../styles/styled-components/box-shadow.js";
import "../../../../styles/styled-components/button.js";
import 'styled-components';
import "../../../../themes/alert.js";
import "../../../../themes/button.js";
import "../../../../themes/checkbox.js";
import "../../../../themes/divider.js";
import "../../../../themes/dropdown.js";
import "../../../../themes/fieldset.js";
import "../../../../themes/input.js";
import "../../../../themes/list.js";
import "../../../../themes/listbox.js";
import "../../../../themes/loader.js";
import "../../../../themes/option.js";
import "../../../../themes/popout.js";
import "../../../../themes/switch.js";
import "../../../../themes/themes.js";
import "../../../../themes/tooltip.js";
import "../../../../styles/styled-components/font-face.js";
import "../../../../styles/styled-components/global.js";
import "../../../../styles/styled-components/input.js";
import "../../../../styles/styled-components/list.js";
import "../../../../styles/styled-components/listitem.js";
import "../../../../styles/styled-components/media-queries.js";
import "../../../../styles/styled-components/reset.js";
import "../../../../styles/styled-components/outline.js";
import "../../../../styles/styled-components/popout.js";
import "../../../../styles/styled-components/screen-reader.js";
import "../../../../styles/styled-components/switch.js";
import "../../../../styles/styled-components/tooltip.js";
import "../../../../utilities/color.js";
import 'date-fns';
import "../../../../utilities/locale.js";
import '@brandfolder/utilities';
import "../../../atoms/button/close-button/close-button.js";
import "../../../atoms/button/color-button/color-button.js";
import "../../../../hooks/use-prevent-keyboard-scrolling.js";
import "../../../atoms/button/icon-button/icon-button.js";
import "../../../atoms/button/standard-button/standard-button.js";
import { CircleLoader } from "../../../atoms/loader/circle-loader/circle-loader.js";
import "../../../atoms/loader/shimmer-loader/shimmer-loader.js";
import "../../../atoms/divider/standard-divider/standard-divider.js";
import "../../../atoms/fieldset/standard-fieldset/standard-fieldset.js";
import "../../../atoms/heading/standard-heading/standard-heading.js";
import "../../../atoms/label/standard-label/standard-label.js";
import "../../../atoms/link/button-link/button-link.js";
import "../../../atoms/link/standard-link/standard-link.js";
import "../../../atoms/popout/standard-popout/standard-popout.js";
import "../../../atoms/screen-reader/only-for-screen-reader/only-for-screen-reader.js";
import "../../../atoms/table/standard-table/caption.js";
import "../../../atoms/table/standard-table/tbody.js";
import "../../../atoms/table/standard-table/tr-empty.js";
import "../../../atoms/table/standard-table/td.js";
import "../../../atoms/table/standard-table/tr.js";
import "../../../atoms/table/standard-table/table.js";
import "../../../atoms/table/standard-table/tfoot.js";
import "../../../atoms/table/standard-table/th.js";
import "../../../atoms/table/standard-table/thead.js";
import "../../../atoms/table/dnd-table/dnd-handle-td.js";
import "../../../atoms/table/dnd-table/dnd-table-drag-context.js";
import "../../../atoms/text/help-text/help-text.js";
import "../../../atoms/text/standard-text/standard-text.js";
import { TabButton } from "./components/tab-button.js";
import { TabList } from "./components/tab-list.js";
import { TabPanel } from "./components/tab-panel.js";
import { TabSlider } from "./components/tab-slider.js";
import { TabUnderline } from "./components/tab-underline.js";
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
/**
 * Base tabs
 * @param props BaseTabsProps
 */
var BaseTabs = function BaseTabs(props) {
  var _props$activatePanelO = props.activatePanelOnPrevNext,
    activatePanelOnPrevNext = _props$activatePanelO === void 0 ? true : _props$activatePanelO,
    caption = props.caption,
    changeToIndex = props.changeToIndex,
    className = props.className,
    id = props.id,
    initialActiveIndex = props.initialActiveIndex,
    loaderLabel = props.loaderLabel,
    loading = props.loading,
    onChange = props.onChange,
    showSlider = props.showSlider,
    showUnderline = props.showUnderline,
    tabButtonProps = props.tabButtonProps,
    tabListProps = props.tabListProps,
    tabPanelProps = props.tabPanelProps,
    tabSliderProps = props.tabSliderProps,
    tabUnderlineProps = props.tabUnderlineProps,
    tabs = props.tabs,
    otherProps = _objectWithoutProperties(props, _excluded);
  var _useState = useState(initialActiveIndex || 0),
    _useState2 = _slicedToArray(_useState, 2),
    activeIndex = _useState2[0],
    setActiveIndex = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    focusIndex = _useState4[0],
    setFocusIndex = _useState4[1];
  var length = tabs.length;
  var zeroBasedLength = length - 1;
  var handleTabChange = function handleTabChange(index) {
    setActiveIndex(index);
    if (onChange) {
      onChange(index);
    }
  };
  /**
  * Handling left arrow, right arrow, spacebar, home, and end keys are required for accessibility compliance
  * https://www.w3.org/TR/wai-aria-practices-1.2/#keyboard-interaction-20
  */
  var handleTabButtonKeyUp = function handleTabButtonKeyUp(e, index) {
    // only handle tab button previous/next if we have more than one tab button
    if (length > 1) {
      // left arrow key goes to the previous tab button or wraps around to the last tab button
      if (e.key === 'ArrowLeft') {
        if (activatePanelOnPrevNext) {
          var prev = activeIndex - 1;
          var prevIndex = prev < 0 ? zeroBasedLength : prev;
          setActiveIndex(prevIndex);
          if (onChange) {
            onChange(prevIndex);
          }
        } else {
          var _prev = (focusIndex || 0) - 1;
          var _prevIndex = _prev < 0 ? zeroBasedLength : _prev;
          setFocusIndex(_prevIndex);
        }
      }
      // right arrow key goes to the next tab button or wraps back around to the first tab button
      if (e.key === 'ArrowRight') {
        if (activatePanelOnPrevNext) {
          var next = activeIndex + 1;
          var nextIndex = next > zeroBasedLength ? 0 : next;
          setActiveIndex(nextIndex);
          if (onChange) {
            onChange(nextIndex);
          }
        } else {
          var _next = (focusIndex || 0) + 1;
          var _nextIndex = _next > zeroBasedLength ? 0 : _next;
          setFocusIndex(_nextIndex);
        }
      }
      // space/spacebar (enter is handled by onClick below)
      if (e.key === ' ' || e.key === 'Spacebar') {
        handleTabChange(index);
      }
      // home goes to the first tab button
      if (e.key === 'Home') {
        if (activatePanelOnPrevNext) {
          setActiveIndex(0);
          if (onChange) {
            onChange(0);
          }
        } else {
          setFocusIndex(0);
        }
      }
      // end goes to the last tab button
      if (e.key === 'End') {
        if (activatePanelOnPrevNext) {
          setActiveIndex(zeroBasedLength);
          if (onChange) {
            onChange(zeroBasedLength);
          }
        } else {
          setFocusIndex(zeroBasedLength);
        }
      }
    }
  };
  useEffect(function () {
    // let the parent component change the tab (if it's a valid tab)
    if (typeof changeToIndex === 'number' && changeToIndex >= 0 && changeToIndex < length && changeToIndex !== activeIndex) {
      setActiveIndex(changeToIndex);
      if (onChange) {
        onChange(changeToIndex);
      }
    }
  }, [changeToIndex]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(function () {
    // for storybook
    if (initialActiveIndex !== undefined) {
      handleTabChange(initialActiveIndex);
    }
  }, [initialActiveIndex]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(function () {
    // if a tab is removed and that was the active tab
    // reset the activeIndex back to the first tab
    if (activeIndex > tabs.length - 1) {
      setActiveIndex(0);
    }
  }, [tabs.length]); // eslint-disable-line react-hooks/exhaustive-deps
  return /*#__PURE__*/React.createElement("div", _extends({}, otherProps, {
    className: classnames(_defineProperty({
      'bf-tabs': true
    }, "".concat(className), !!className)),
    id: id
  }), /*#__PURE__*/React.createElement(TabList, _extends({}, tabListProps, {
    caption: caption
  }), tabs.map(function (tab, index) {
    return /*#__PURE__*/React.createElement(TabButton, _extends({}, tabButtonProps, {
      key: "".concat(id, "-button-").concat(index),
      active: activeIndex === index,
      activeIndex: activeIndex,
      disabled: tab.disabled,
      focusIndex: focusIndex,
      id: "".concat(id, "-button-").concat(index),
      index: index,
      onClick: function onClick() {
        return handleTabChange(index);
      },
      onKeyUp: function onKeyUp(e) {
        return handleTabButtonKeyUp(e, index);
      },
      tabPanelId: "".concat(id, "-panel-").concat(index)
    }), tab.tabButton);
  }), showSlider && /*#__PURE__*/React.createElement(TabSlider, _extends({}, tabSliderProps, {
    activeIndex: activeIndex,
    numberOfTabs: length
  })), showUnderline && /*#__PURE__*/React.createElement(TabUnderline, _extends({}, tabUnderlineProps))), tabs.map(function (tab, index) {
    return /*#__PURE__*/React.createElement(TabPanel, _extends({}, tabPanelProps, {
      key: "".concat(id, "-panel-").concat(index),
      active: activeIndex === index,
      id: "".concat(id, "-panel-").concat(index),
      tabButtonId: "".concat(id, "-button-").concat(index)
    }), !loading && !tab.loading && tab.tabPanel, loaderLabel && (loading || tab.loading) && /*#__PURE__*/React.createElement(CircleLoader, {
      label: loaderLabel
    }));
  }));
};
export { BaseTabs };